<carm-card class="carm-widget carm-summary-widget">
  <carm-card-title>
    <div class="row">
      <div
      class="col-md-12 inline-content"
      data-cy="access-requests-homepage-title">
          <span>{{'dashboard.widgets.access_requests.title' | translate }}</span>
      </div>
    </div>
  </carm-card-title>
  <carm-card-content>

    <div class="row mrgn-bttm-0">
      <div class="col-md-6 splitter">
        <div class="row">
          <div
          class="col-md-12 mrgn-tp-sm text-center font-1_3x"
          data-cy="access-requests-pending-employee-title">
          <strong>{{'dashboard.widgets.access_requests.pending_employee' | translate }}</strong>
          <carm-popover class="mrgn-lft-sm mrgn-tp-sm">
            {{'dashboard.widgets.access_requests.tooltip_employee' | translate }}
          </carm-popover>
          </div>
        </div>
        <div class="row" *ngIf="!loading && carmResourcesEnum && groupTypeEnum">
          <div class="col-md-12 mrgn-tp-md text-center font-2_5x break-all" *carm-acl-group="[carmResourcesEnum.EMPLOYEE, groupTypeEnum.Reader]">
            <strong >{{ pendingEmployeeRequests }}</strong>
          </div>
        </div>
        <div class="row" *ngIf="!loading && carmResourcesEnum && groupTypeEnum" >
          <div
          *carm-acl-group="[carmResourcesEnum.EMPLOYEE, groupTypeEnum.Reader]"
          class="col-md-12 mrgn-tp-sm text-center"
          >
          <em><a
            [carmRouterLink]="viewAllEmployeeRequestsUrl"
            data-cy="access-requests-homepage-title">{{'dashboard.widgets.access_requests.view_employee' | translate }}</a></em>
            
          </div>
        </div>
        <div class="row" *ngIf="loading" style="max-height: 66px !important;">
          <mat-progress-spinner
          attr.aria-label="{{ 'application_features.loading' | translate }}"
          class="mat-spinner-color spinner-styling"
          mode="indeterminate"
          value="50"
        >
        </mat-progress-spinner>
        </div>
      </div>

      <div class="col-md-6 mrgn-bttm-0">
        <div class="row">
          <div
          class="col-md-12 mrgn-tp-sm text-center font-1_3x"
          data-cy="pending-access-requests">
          <strong>{{'dashboard.widgets.access_requests.pending_third_partry' | translate }}</strong>
          <carm-popover class="mrgn-lft-sm mrgn-tp-sm">
            {{'dashboard.widgets.access_requests.tooltip_third_partry' | translate }}
          </carm-popover>
          </div>
        </div>
        <div class="row" *ngIf="!loading && carmResourcesEnum && groupTypeEnum">
          <div class="col-md-12 mrgn-tp-md text-center font-2_5x" *carm-acl-group="[carmResourcesEnum.MANAGE_RELATIONSHIPS, groupTypeEnum.Editor]">
            <strong data-cy="access-requests-third-party-count" >{{ thirdPartyAccessRequests }}</strong>
          </div>
        </div>
        <div class="row" *ngIf="loading" style="max-height: 66px !important;">
          <mat-progress-spinner
          attr.aria-label="{{ 'application_features.loading' | translate }}"
          class="mat-spinner-color spinner-styling"
          mode="indeterminate"
          value="50"
        >
        </mat-progress-spinner>
        </div>
        <div class="row" *ngIf="!loading && carmResourcesEnum && groupTypeEnum" >
          <div
          *carm-acl-group="[carmResourcesEnum.MANAGE_RELATIONSHIPS, groupTypeEnum.Editor]"
          class="col-md-12 mrgn-tp-sm text-center"
          >
          <em><a
            [carmRouterLink]="viewAllAccessRequestsUrl"
            data-cy="view-all-access-requests">{{'dashboard.widgets.access_requests.view_third_partry' | translate }}</a></em>
            
          </div>
        </div>
      </div>
    </div>







  </carm-card-content>
</carm-card>
